const MicroTokenKey = 'micro_access_token'
const MicroExpiresToken = 'micro_expires_in'

export function getMicroToken() {
  return localStorage.getItem(MicroTokenKey)
}

export function setMicroToken(token) {
  localStorage.setItem(MicroTokenKey, `${token.token_type} ${token.token}`)
  localStorage.setItem(MicroExpiresToken, `${token.expires_in}`)
}

export function removeMicroToken() {
  localStorage.removeItem(MicroExpiresToken)
  return localStorage.removeItem(MicroTokenKey)
}

// Expires Token
export function getMicroExpiresToken() {
  return localStorage.getItem(MicroExpiresToken)
}
